// Build selected_locations payload and primary state/county from modal selections
export default function buildSelectedLocations({ modalStateIds = [], modalSelectedCounties = {}, modalCountiesMap = {}, states = [] }) {
  const selected_locations = (modalStateIds || []).map((sId) => {
    const stateObj = states.find((s) => (s.id || s.stateid || s.value) === sId) || { id: sId };
    const cArr = modalCountiesMap[sId] || [];
    const counties = (modalSelectedCounties[sId] || []).map((cId) => {
      const cObj = cArr.find((c) => (c.id || c.countyid || c.value) === cId) || { id: cId };
      return {
        countyid: cObj.id || cObj.countyid || cId,
        county_name: cObj.countyname || cObj.name || cObj.county_name || '',
      };
    });
    return {
      stateid: stateObj.id || stateObj.stateid || sId,
      state_code: stateObj.statecode || stateObj.code || stateObj.state_code || '',
      state_name: stateObj.statename || stateObj.name || stateObj.state_name || '',
      counties,
    };
  });

  const primaryStateId = (modalStateIds && modalStateIds.length) ? modalStateIds[0] : null;
  const primaryCountyId = primaryStateId ? ((modalSelectedCounties[primaryStateId] || [])[0] || null) : null;
  return { selected_locations, primaryStateId, primaryCountyId };
}
